/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Score_Value_For_MoneyInputs */

const en_directory_score_value_for_money = /** @type {(inputs: Directory_Score_Value_For_MoneyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value for money`)
};

const zh_directory_score_value_for_money = /** @type {(inputs: Directory_Score_Value_For_MoneyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性价比`)
};

/**
* | output |
* | --- |
* | "Value for money" |
*
* @param {Directory_Score_Value_For_MoneyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_score_value_for_money = /** @type {((inputs?: Directory_Score_Value_For_MoneyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Score_Value_For_MoneyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_score_value_for_money(inputs)
	return zh_directory_score_value_for_money(inputs)
});
export { directory_score_value_for_money as "directory.score.value_for_money" }